import { Loader } from 'semantic-ui-react'
import { t } from 'shared'

const reload = () => window.location.reload()
export const GenericRetriableError = ({ error }: { error?: Error }) => {
  if (error) {
    if (/error_404|invalid_authenticity_token|missing_session/.test(error.message)) {
      // will be globally handled by redirect, don't notify
      return <Loader active />
    }
  }

  return (
    <div style={{ textAlign: 'center', paddingTop: 30 }}>
      <h1 className="ui header">{t('misc.whoops')}</h1>
      <p>{t('misc.generic_error')}</p>
      <a href="#" onClick={reload}>
        {t('verbs.try_again')}
      </a>
    </div>
  )
}
